/* FEED PAGE */
Vue.component('feedpage',{
    template:'#feedpage-template',
    data:function(){
        return{
            Autolinker: Autolinker,
            deadlineToggle: false,
            searchString: '',
            user_activities:[],
            feed:[],
            moderator:1,
            current_user_id:-1,
            modal:'',
            result_type:'actual', //actual | expired
            activeorder:'',
            moment: moment,
            client: [],
            project: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false,
            brands:[],
            subBrands:[],
            activeClient:{
                id:'-1'
            },
            activeClientId:'-1',
            activeBrand:'',
            activeBrandId:'-1',
            activeSubBrand:{
                id:'-1'
            },
            activeSubBrandId:'-1',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            projects:'',
            recentProjectNumbers:[],
            projectnumbersearchstring:'',
            ticket_name_search_string: '',
            loaderIsActive:true,
            showByStatus:'open',
            showByStatusSecond:'open',
            current_user_id:-1,
            clients: [],
            searchString:'',
            divisions: [],
            activeDivisionId: '',
            activeUserId: '',
            users: [],
            orderDirection: -1,
            deadlineSort: false,
            orderType: "created_at",
            ticketProjectSearch: '',
            filtered:[]
        };
    },
    created:function(){
        activeInstance = this;

        setTimeout(function(){

            activeInstance.getClients();
            //SET CURRENT USER ID BASED ON HIDDEN INPUT IN TEMPLATE
            activeInstance.current_user_id = $("#current_user_id").val();
            activeInstance.getFeedList();
            activeInstance.modal = $('body').find('#edit_comment_deadline').html();
            //SET CURRENT USESR ID BASED ON HIDDEN INPUT IN TEMPLATE
            activeInstance.current_user_id = $("#current_user_id").val();
            activeInstance.getDivisions();
            activeInstance.getUsers();

        },200);



    },
    watch: {
        deadlineSort: function() {
            this.orderType = (this.deadlineSort) ? 'mostRecentDeadline' : 'created_at';
            if(activeInstance.deadlineSort == false) {
                activeInstance.orderDirection=-11;
            }
            else {
                activeInstance.orderDirection=1;
            }
        },
        result_type:function(){

        },
        activeClientId:function() {
            activeInstance.clientsFilter();
        },
        activeBrandId:function() {
            activeInstance.clientsFilter();
        },
        activeSubBrandId:function() {
            activeInstance.clientsFilter();
        },
        activeDivisionId:function() {
            activeInstance.clientsFilter();
        },
        ticketProjectSearch:function() {
            activeInstance.clientsFilter();
        },
        projectnumbersearchstring:function() {
            activeInstance.clientsFilter();
        },
        activeUserId:function() {
            activeInstance.clientsFilter();
        }
    },
    methods:{
        editComment:function(comment){


            activeInstance.active_comment = comment;


            bootbox.dialog({
                title: "Komment határidő szerkesztése",
                message: activeInstance.modal,
                buttons: {
                    success: {
                        label: "Save",
                        className: "btn-success",
                        callback: function () {

                            $('.field').removeClass('error');
                            var validation = true;

                            //VALIDATE EVERYTHING!!
                            //var name=  $('.bootbox-body').find('#field_name').val();

                            var deadline =  $('.modal-content').find('#comment_deadline').val();

                            if(validation == true){
                                activeInstance.$http.post(baseURL+'/admin/comment/update',{
                                    'comment_id':comment.id,
                                    'deadline': deadline
                                }).then(function(response){
                                    activeInstance.active_comment.deadline=deadline;
                                });
                            }else{
                                return false;
                            }
                        }
                    }
                }
            });

            setTimeout(function(){
                $(function () {
                    $('.modal-content').find('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD HH:00',
                        locale: 'hu',
                    });

                    $('.modal-content').find('#comment_deadline').val(comment.deadline);
                });
            },700);

        },
        humanDate:function($date){
            return moment($date).fromNow();

        },
        checkDeadline:function(feed_record){

            if(activeInstance.deadlineSort == false){
                return true;
            }

            if(activeInstance.result_type=='actual'){

                var result = false;
                feed_record.mostRecentDeadline = null;

                activeInstance.filtered.forEach(function(originalRecord){
                    if(originalRecord.id == feed_record.id){
                        originalRecord.mostRecentDeadline = null;
                    }
                });

                if(feed_record.project != null){
                    if( moment(feed_record.project.deadline) > moment() ) {

                            feed_record.mostRecentDeadline = feed_record.project.deadline;
                            activeInstance.filtered.forEach(function(originalRecord){
                                if(originalRecord.id == feed_record.id){
                                    originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                }
                            });

                        result = true;
                    }
                }


                //IF WE GOT A TICKET
                if(feed_record.ticket!=null){

                    // IF THE DEADLINE IS IN THE FUTURE
                    if( moment(feed_record.ticket.deadline) > moment() ) {
                        result = true;

                        if( feed_record.mostRecentDeadline != null ){

                            //IF THE DEADLINE IS MORE RECENT THEN THE CURRENT
                            if( moment(feed_record.ticket.deadline) < moment(feed_record.mostRecentDeadline) ){

                                //SET THE VALUE
                                feed_record.mostRecentDeadline = feed_record.ticket.deadline;

                                //SET THE VALUE IN THE ORIGINAL ARRAY ASWELL
                                activeInstance.filtered.forEach(function(originalRecord){
                                    if(originalRecord.id == feed_record.id){
                                        originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                    }
                                });

                            }

                        }
                        else{
                            //SET THE VALUE
                            feed_record.mostRecentDeadline = feed_record.ticket.deadline;
                            //SET THE VALUE IN THE ORIGINAL ARRAY ASWELL
                            activeInstance.filtered.forEach(function(originalRecord){
                                if(originalRecord.id == feed_record.id){
                                    originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                }
                            });
                        }
                    }
                }

                if(feed_record.comment!=null){
                    if( feed_record.comment.has_deadline == true && moment(feed_record.comment.deadline) > moment() ) {

                        if(moment(feed_record.comment.deadline) < moment(feed_record.mostRecentDeadline) ){

                            feed_record.mostRecentDeadline = feed_record.comment.deadline;

                            activeInstance.feed.forEach(function(originalRecord){
                                if(originalRecord.id == feed_record.id){
                                    originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                }
                            });
                        }
                        result = true;
                    }
                }

                console.log(feed_record);

                return result;
            }


            if(activeInstance.result_type=="expired"){
                var result = false;
                feed_record.mostRecentDeadline = null;

                activeInstance.filtered.forEach(function(originalRecord){
                    if(originalRecord.id == feed_record.id){
                        originalRecord.mostRecentDeadline = null;
                    }
                });

                if(feed_record.project != null){
                    if( moment(feed_record.project.deadline) < moment() ) {

                        feed_record.mostRecentDeadline = feed_record.project.deadline;
                        activeInstance.filtered.forEach(function(originalRecord){
                            if(originalRecord.id == feed_record.id){
                                originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                            }
                        });

                        result = true;
                    }
                }


                //IF WE GOT A TICKET
                if(feed_record.ticket!=null){

                    // IF THE DEADLINE IS IN THE PAST
                    if( moment(feed_record.ticket.deadline) < moment() ) {
                        result = true;

                        if( feed_record.mostRecentDeadline != null ){

                            //IF THE DEADLINE IS MORE RECENT THEN THE CURRENT
                            if( moment(feed_record.ticket.deadline) > moment(feed_record.mostRecentDeadline) ){

                                //SET THE VALUE
                                feed_record.mostRecentDeadline = feed_record.ticket.deadline;

                                //SET THE VALUE IN THE ORIGINAL ARRAY ASWELL
                                activeInstance.filtered.forEach(function(originalRecord){
                                    if(originalRecord.id == feed_record.id){
                                        originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                    }
                                });
                            }
                        }
                        else{
                            //SET THE VALUE
                            feed_record.mostRecentDeadline = feed_record.ticket.deadline;
                            //SET THE VALUE IN THE ORIGINAL ARRAY ASWELL
                            activeInstance.filtered.forEach(function(originalRecord){
                                if(originalRecord.id == feed_record.id){
                                    originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                }
                            });
                        }
                    }
                }


                if(feed_record.comment!=null){
                    if( feed_record.comment.has_deadline == true && moment(feed_record.comment.deadline) < moment() ) {

                        if(moment(feed_record.comment.deadline) > moment(feed_record.mostRecentDeadline) ){

                            feed_record.mostRecentDeadline = feed_record.comment.deadline;

                            activeInstance.feed.forEach(function(originalRecord){
                                if(originalRecord.id == feed_record.id){
                                    originalRecord.mostRecentDeadline = feed_record.mostRecentDeadline;
                                }
                            });
                        }
                        result = true;
                    }
                }

                console.log(feed_record);

                return result;
            }


        },
        getFeedList:function(){

            showLoadingOverlay();
            Vue.http.get(baseURL+'/ajax/feed/list').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.feed = response.data;
                setTimeout( function(){
                    activeInstance.clientsFilter(activeInstance.feed);
                },200 );

                setTimeout(function() {
                    if(window.location.hash) {
                        var id = location.hash.replace('#','');
                        $('html, body').animate({
                            scrollTop: $('#'+id).offset().top-100
                        }, 200);

                    } else {
                        // Fragment doesn't exist
                    }
                },400);

            }).bind(this);

            setInterval(function(){
                //showLoadingOverlay();
                Vue.http.get(baseURL+'/ajax/feed/list').then(function(response){
                    console.log("Auto refresh");
                    //$('body').LoadingOverlay("hide");
                    activeInstance.feed = response.data;
                    activeInstance.clientsFilter(activeInstance.feed);
                }).bind(this);
            },30000);
        },
        compareLowestDeadlines: function(){
            if (a.lowest_deadline < blowest_deadline){
                return -1;
            }
            if (a.lowest_deadline > b.lowest_deadline) {
                return 1;
            }
            return 0;
        },
        clientsFilter: function() {
            console.log('filtering');
            var new_arr = activeInstance.feed;

            var client_id = activeInstance.activeClientId;
                brand_id = activeInstance.activeBrandId;
                sub_brand_id = activeInstance.activeSubBrandId;
                user_id = activeInstance.activeUserId;
                division_id = activeInstance.activeDivisionId;
                console.log(new_arr);

            if (activeInstance.deadlineSort == true) {

                new_arr = new_arr.filter(function(item) {
                    var decision = false;

                    if(item.project!=null) {
                        console.log('got a project');
                        decision = true;
                    }

                    if(item.comment!=null){
                        if(item.comment.has_deadline == true) {
                            console.log('got a comment');
                            decision = true;
                        }
                    }

                    if(item.ticket != null){
                        if(item.ticket != null) {
                            console.log('got a ticket');
                            decision = true;
                        }
                    }

                    return decision;
                });

            }

            if (client_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.client.id == client_id;
                });
            } else if(client_id == -1) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.client.id >0;
                });
            }
            if (brand_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.brand.id == brand_id;
                });
            }
            else if(brand_id == -1) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.brand_id > 0;
                });
            }
            if (sub_brand_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.sub_brand.id == sub_brand_id;
                });
            }
            else if(sub_brand_id == -1) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.sub_brand_id > 0;
                });
            }

            if (division_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.division_id == division_id;
                });
            }

            if (user_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.project.supervisor_user_id == user_id;
                });
            }

            if (activeInstance.projectnumbersearchstring.length > 0) {
                new_arr = new_arr.filter(function(item) {
                    return (item.project.project_number.toLowerCase().indexOf(activeInstance.projectnumbersearchstring.toLowerCase()) > -1 );
                });
            }

            if (activeInstance.ticketProjectSearch.length > 0) {

                function removeDuplicates(myArr, prop) {
                    return myArr.filter(function (obj, pos, arr) {
                        return arr.map(function (mapObj) {
                            return mapObj[prop];
                        }).indexOf(obj[prop]) === pos;
                    });
                }

                var projects = new_arr.filter(function(item) {
                    return item.project.name.toLowerCase().indexOf(activeInstance.ticketProjectSearch.toLowerCase()) > -1;
                });


                var tickets = new_arr.filter(function(item) {
                    var contains = false;
                    for(var i = 0, i_l = item.project.tickets.length; i < i_l; i ++) {
                        if (item.project.tickets[i].name.toLowerCase().indexOf(activeInstance.ticketProjectSearch.toLowerCase()) > -1) {
                            contains = true;
                        }
                    }
                    return contains;
                });

                new_arr = removeDuplicates(projects.concat(tickets), 'id');
            }

            console.log('filtered.');
            console.log(new_arr);
            console.log(activeInstance.filtered);
            activeInstance.filtered = new_arr;
        },
        onClientChange: function(data){
            //activeInstance.activeClient = data;
            activeInstance.getClientBrands(activeInstance.activeClient.id);
        },
        getClients: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/client/list/all')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.clients = response.data;
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        showAll:function(){
            activeInstance.showByStatus = 'open';
            activeInstance.showByStatusSecond = 'closed';
            activeInstance.getUserProjects('all');
        },
        showActive:function(){
            activeInstance.showByStatus = 'open';
            activeInstance.showByStatusSecond = 'open';
            activeInstance.getUserProjects('active');
        },
        closeTicket:function(ticket){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/ticket/close', {
                'ticket_id':ticket.id
            })
                .then(function (response) {
                    console.log(response);
                    ticket.status='closed';
                    setTimeout(function(){
                        $('body').LoadingOverlay("hide");
                    },200);

                })
                .catch(function (error) {
                    console.log(error);
                    $('body').LoadingOverlay("hide");
                });
        },
        goToTicketPage:function(project,ticket){
            location.href=baseURL+'/admin/project/'+project.id+'/ticket/'+ticket.id;
        },
        getDivisions: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/divisions/get/active').then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.divisions = response.data;

            }).catch(function (error) {
                console.log(error);
                $('body').LoadingOverlay("hide");
            });
        },
        getUsers: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/users/active').then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.users = response.data;
            }).catch(function (error) {
                console.log(error);
                $('body').LoadingOverlay("hide");
            });
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(id){
            activeInstance.activeClientId=id;
            activeInstance.activeBrandId='-1';
            activeInstance.activeBrand=[];
            activeInstance.activeSubBrandId='-1';
            activeInstance.activeSubBrand=[];
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
                activeInstance.subBrands = [];
                activeInstance.activeSubBrandId='-1';
            }).bind(this);
        },

        //WHEN SELECTING A BRAND -> GET THE BELONGING SUB BRANDS
        getBrandSubBrands:function(event,data){
            var activeBrand = $(event.target).val();
            activeInstance.activeBrandId = activeBrand;

            activeInstance.subBrands = [];
            activeInstance.activeSubBrandId='-1';

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrandId).then(function(response){
                //console.log(response);
                activeInstance.subBrands = response.data;
            }).bind(this);


        },
        setActiveSubBrand:function(event){

            var subBrandId = $(event.target).val();
            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        }
    }
});
